const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-smile-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-vip-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

interface CategoryDropdownProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function CategoryDropdown({ isOpen, onClose }: CategoryDropdownProps) {
  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-foreground-950/30 z-40"
        onClick={onClose}
      />
      <div className="fixed top-20 left-1/2 -translate-x-1/2 z-50 w-full max-w-2xl mx-4">
        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden max-h-[75vh] overflow-y-auto">
          <div className="sticky top-0 bg-background-50 p-5 border-b border-background-200/60 flex items-center justify-between z-10">
            <div>
              <h3 className="text-base font-semibold text-foreground-900 font-heading">Categorie Prodotti</h3>
              <p className="text-xs text-foreground-500 font-body mt-0.5">Scegli una categoria per esplorare i prodotti</p>
            </div>
            <button
              onClick={onClose}
              className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer flex-shrink-0"
            >
              <i className="ri-close-line text-lg text-foreground-600"></i>
            </button>
          </div>

          <div className="p-3 grid grid-cols-1 sm:grid-cols-2 gap-1.5">
            {categories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-3 px-4 py-3.5 rounded-xl hover:bg-background-100 transition-colors cursor-pointer group"
              >
                <div className="w-9 h-9 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                  <i className={`${cat.icon} text-accent-600 text-sm`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <span className="text-sm text-foreground-800 font-body group-hover:text-foreground-950 transition-colors block truncate">
                    {cat.name}
                  </span>
                </div>
                <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-foreground-600 transition-colors flex-shrink-0"></i>
              </a>
            ))}
          </div>

          <div className="p-5 border-t border-background-200/60 bg-background-50">
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 flex-1 px-4 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap font-label"
              >
                Vedi tutti i prodotti
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 flex-1 px-4 py-2.5 bg-foreground-900 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap font-label"
              >
                Acquista Ora
                <i className="ri-shopping-cart-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export { categories };